import { Component } from '@angular/core';

@Component({
  selector: 'app-home-public',
  imports: [],
  templateUrl: './home-public.html',
  styleUrl: './home-public.scss',
})
export class HomePublic {

}
